import styled from 'styled-components';
import IconChevronDownCircleOutline from './IconChevronDownCircleOutline';
var IconChevronRightCircleOutline = /*#__PURE__*/styled(IconChevronDownCircleOutline).withConfig({
  displayName: "IconChevronRightCircleOutline",
  componentId: "c11n-8-111-1__sc-1mu1qof-0"
})(["transform:rotate(270deg);"]);
export default IconChevronRightCircleOutline;